export default "__VITE_ASSET__B3w8dL$q__"